// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // cloudUrl: 'http://localhost:8080/api/v1/',
  // imageUrl: 'http://localhost:8080/api/v1/advertisement/image/',
  // SOCKET_ENDPOINT: 'http://localhost:8080',
  // ihmUrl: 'http://dev.nautiluslog.com',
  // mode: 'offline',
  // cloudUrl: 'http://192.168.100.231:8080/api/v1/',
  // imageUrl: 'http://192.168.100.231:8080/api/v1/advertisement/image/',
  // SOCKET_ENDPOINT: 'http://192.168.100.231:8080',
  // ihmUrl: 'http://dev.nautiluslog.com',
  // mode: 'offline',
  // mode: 'online',

  // cloudUrl: 'http://54.238.96.125:8888/api/v1/',
  // imageUrl: 'http://54.238.96.125:8888/api/v1/advertisement/image/',
  // SOCKET_ENDPOINT: 'http://54.238.96.125:8888',
  ihmUrl: 'http://dev.nautiluslog.com',
  mode: 'online',
  // mode: 'offline',
  cloudUrl: 'https://backend.msg-search.com/api/v1/',
  imageUrl: 'https://backend.msg-search.com/api/v1/advertisement/image/', 
  SOCKET_ENDPOINT: 'https://backend.msg-search.com',


  // cloudUrl: 'http://127.0.0.1:8080/api/v1/',
  // imageUrl: 'http://127.0.0.1:8080/api/v1/advertisement/image/',
  // SOCKET_ENDPOINT: 'http://127.0.0.1:8080',
  // mode: 'offline',
  // ihmUrl: 'http://dev.nautiluslog.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error'; // Included with Angular CLI.
